import { render, staticRenderFns } from "./viewModules.vue?vue&type=template&id=023e2bb0&scoped=true&"
import script from "./viewModules.vue?vue&type=script&lang=js&"
export * from "./viewModules.vue?vue&type=script&lang=js&"
import style0 from "./viewModules.vue?vue&type=style&index=0&id=023e2bb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023e2bb0",
  null
  
)

export default component.exports